import * as types from './mutation-types'
import { API_STATES } from '@/helpers'
import { uniq, isUndefined } from "lodash";

const mutations = {
  [types.GET_TASK_CARD_DATA_BEGIN](state) {
    state.taskCardDataGetState = API_STATES.REQUEST_PENDING
  },
  [types.GET_TASK_CARD_DATA_SUCCESS](state, tasks) {
    state.taskCardDataGetError = null
    state.tasks = tasks
    
    if(state.taskCardFilter.userFilter[0] === '') {
      state.taskCardFilter.userFilter=uniq(tasks.map(t=>t.assignee.id))
    }  
     

    state.taskCardDataGetState = API_STATES.REQUEST_SUCCESS
  },
  [types.GET_TASK_CARD_DATA_ERROR](state, err) {
    state.taskCardDataGetState = API_STATES.REQUEST_ERROR
    state.taskCardDataGetError = err
  },

  [types.SET_TASKCARD_FILTER_DATA](state, { userFilter, date, showDescription }) {
   
    if(userFilter){ 
      state.taskCardFilter.userFilter = userFilter  
    }
    
    if(date){
      state.taskCardFilter.userFilter=['']
      state.taskCardFilter.date = date
      
    }

    if(!isUndefined(showDescription)){
      state.taskCardFilter.showDescription = showDescription
    }
  },

  [types.SEND_TASK_EMAIL_BEGIN](state) {
    state.sendEmailState = API_STATES.REQUEST_PENDING
  },
  [types.SEND_TASK_EMAIL_SUCCESS](state,message){
    state.sendEmailState = API_STATES.REQUEST_SUCCESS
    state.sendEmailError = null;
    state.showSuccessMessage = message
  },
  [types.SEND_TASK_EMAIL_ERROR](state, err) {
    state.sendEmailState = API_STATES.REQUEST_ERROR
    state.sendEmailError = err;
  },
}
    
export default mutations